var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11537 9.50978C4.85221 9.22908 4.85221 9.22908 5.22063 9.12381L17.975 5.36943C18.4662 5.21153 18.4662 5.21153 18.3083 5.70276L14.554 18.4571C14.4487 18.8431 14.4487 18.8431 14.168 18.5624L5.11537 9.50978ZM3.71186 10.9133L12.7645 19.9659C14.0101 21.2291 15.9926 20.7203 16.4838 19.0186L20.2382 6.26416C20.782 4.45715 19.2206 2.89574 17.4136 3.4396L4.65923 7.19399C2.95747 7.7203 2.43116 9.65013 3.71186 10.9133ZM12.2382 10.0361L8.23817 14.0361C8.04519 14.2115 7.93993 14.4571 7.93993 14.7378C7.93993 15.2817 8.39607 15.7378 8.93993 15.7378C9.22063 15.7378 9.46624 15.6326 9.64168 15.4396L13.6417 11.4396C13.8347 11.2642 13.9399 11.0186 13.9399 10.7378C13.9399 10.194 13.4838 9.73785 12.9399 9.73785C12.6592 9.73785 12.4136 9.84311 12.2382 10.0361Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendOutlined);
export default __webpack_public_path__ + "static/media/send_outlined.8e1d6d1e.svg";
export { ForwardRef as ReactComponent };